import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {

  @Input() name: string;
  @Input() dropdownList: string[] = ['List 1', 'List 2', 'List 3'];
  @Output() choosen = new EventEmitter<string>();

  isShowing = false;
  fade = false;
  outsideClickEnable = false;
  choosenItem: string;

  ngOnInit() {
    this.choosenItem = this.dropdownList[0];
  }

  show() {
    if (!this.isShowing) {
      this.isShowing = true;
      setTimeout(() => {
        this.fade = true;
        this.outsideClickEnable = true;
      }, 10);
    } else {
      this.hide();
    }
  }

  hide() {
    this.fade = false;
    this.outsideClickEnable = false;
    setTimeout(() => {
      this.isShowing = false;
    }, 300);
  }

  choose(item: string) {
    this.choosenItem = item;
    this.choosen.emit(item);
    this.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/_common/dropdown/dropdown.component.ts